import React from "react";
import "./CoursePage.css";
import AdcaBanner from "../Component/banner1.jpg";

const AdcaPage = () => {
  return (
    <div className="course-page">
      <div className="course-banner">
        <img src={AdcaBanner} alt="ADCA" className="banner-img" />
      </div>

      <div className="course-content">
        <h2>ADCA – Advance Diploma in Computer Applications</h2>

        <p className="course-text">
          The <strong>ADCA (Advanced Diploma in Computer Applications)</strong> program
          at <strong>Career Point of Information Technology (CPIT)</strong> is designed
          to develop essential technical and professional computer skills for students.
          It provides a strong foundation in information technology and digital literacy.
        </p>

        <p className="course-text">
          Students are trained in office applications such as MS Word, Excel, PowerPoint,
          and Access, alongside database management and internet concepts. The course
          emphasizes practical exposure to help learners adapt to real-world requirements.
        </p>

        <p className="course-text">
          CPIT ensures that learners gain proficiency in computer networks, accounting software,
          and communication tools — all necessary for success in today’s workplaces. Trainers
          focus on both individual skill-building and group project collaboration.
        </p>

        <p className="course-text">
          The ADCA course also includes modules on Tally, IT fundamentals, and digital communication.
          Students receive real-time exposure through projects, ensuring strong employability
          and technical confidence.
        </p>

        <p className="course-text">
          Upon completion, candidates can work as <strong>Computer Operators</strong>,
          <strong> Data Entry Professionals</strong>, or <strong>Office Executives</strong>,
          or pursue higher certifications such as O Level and A Level.
        </p>

        <p className="course-text mb-0">
          CPIT’s ADCA program blends learning, practice, and professional preparation — 
          creating capable, confident, and career-ready individuals in the field of IT.
        </p>
      </div>
    </div>
  );
};

export default AdcaPage;
